import React from "react";
import FetchTVShows from "../../components/FetchTVShows/FetchTVShows";

const TVShows = () => {
  return <FetchTVShows slug="airing_today" pageTitle="Airing Today" />;
};

export default TVShows;
